import React from 'react'

import Script from 'dangerous-html/react'

import './footer.css'

const Footer = (props) => {
  return (
    <div className="footer-container1">
      <footer className="footer-wrapper">
        <div aria-hidden="true" className="footer-wave-divider">
          <svg
            viewBox="0 0 1440 120"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            preserveAspectRatio="none"
          >
            <path
              d="M0 120V46.7C120 23.3 240 0 360 0C480 0 600 46.7 720 46.7C840 46.7 960 0 1080 0C1200 0 1320 23.3 1440 46.7V120H0Z"
              fill="var(--color-surface-elevated)"
            ></path>
          </svg>
        </div>
        <div className="footer-main-container">
          <div className="footer-content-grid">
            <div className="footer-brand-column">
              <div className="footer-logo-group">
                <span className="footer-brand-name">Clementine Nexus</span>
                <span className="footer-brand-tagline">
                  Your Synthetic Teammate
                </span>
              </div>
              <p className="footer-description section-content">
                A persona-driven AI collaborator designed to bring warmth,
                intelligence, and seamless support to your creative and
                professional workflows.
              </p>
              <div className="footer-social-links">
                <a href="#">
                  <div aria-label="LinkedIn" className="footer-social-btn">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <g
                        fill="none"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                      >
                        <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2a2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6M2 9h4v12H2z"></path>
                        <circle cx="4" cy="4" r="2"></circle>
                      </g>
                    </svg>
                  </div>
                </a>
                <a href="#">
                  <div aria-label="Twitter" className="footer-social-btn">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <path
                        fill="none"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M22 4s-.7 2.1-2 3.4c1.6 10-9.4 17.3-18 11.6c2.2.1 4.4-.6 6-2C3 15.5.5 9.6 3 5c2.2 2.6 5.6 4.1 9 4c-.9-4.2 4-6.6 7-3.8c1.1 0 3-1.2 3-1.2"
                      ></path>
                    </svg>
                  </div>
                </a>
                <a href="#">
                  <div aria-label="Instagram" className="footer-social-btn">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <g
                        fill="none"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                      >
                        <rect
                          width="20"
                          height="20"
                          x="2"
                          y="2"
                          rx="5"
                          ry="5"
                        ></rect>
                        <path d="M16 11.37A4 4 0 1 1 12.63 8A4 4 0 0 1 16 11.37m1.5-4.87h.01"></path>
                      </g>
                    </svg>
                  </div>
                </a>
              </div>
            </div>
            <div className="footer-nav-column">
              <h2 className="footer-nav-title section-subtitle">Navigation</h2>
              <nav className="footer-nav-links">
                <a href="/">
                  <div className="footer-link">
                    <span>Homepage</span>
                  </div>
                </a>
                <a href="/story">
                  <div className="footer-link">
                    <span>About Clementine / Story</span>
                  </div>
                </a>
                <a href="/contact">
                  <div className="footer-link">
                    <span>Book a Call / Contact</span>
                  </div>
                </a>
              </nav>
            </div>
            <div className="footer-contact-column">
              <h2 className="footer-nav-title section-subtitle">Connect</h2>
              <div className="footer-contact-info">
                <div className="footer-contact-item">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                    >
                      <path d="m22 7l-8.991 5.727a2 2 0 0 1-2.009 0L2 7"></path>
                      <rect width="20" height="16" x="2" y="4" rx="2"></rect>
                    </g>
                  </svg>
                  <span className="section-content">
                    hello@clementine.nexus
                  </span>
                </div>
                <div className="footer-contact-cta">
                  <p className="footer-cta-text section-content">
                    Ready to integrate intelligence with personality?
                  </p>
                  <a href="/contact">
                    <div className="footer-cta-btn btn btn-primary btn-sm">
                      <span>Start Collaboration</span>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                      >
                        <path
                          fill="none"
                          stroke="currentColor"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M5 12h14m-7-7l7 7l-7 7"
                        ></path>
                      </svg>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="footer-bottom-bar">
            <div className="footer-legal-links">
              <a href="#">
                <div className="footer-legal-link">
                  <span>Privacy Policy</span>
                </div>
              </a>
              <a href="#">
                <div className="footer-legal-link">
                  <span>Terms of Service</span>
                </div>
              </a>
            </div>
            <p className="footer-copyright">
              &amp;copy; 2026 Clementine Nexus. All rights reserved. Designed
              for Human-AI Harmony.
            </p>
          </div>
        </div>
      </footer>
      <div className="footer-container2">
        <div className="footer-container3">
          <Script
            html={`<script defer data-name="footer-interaction">
(function(){
  const footerReveal = () => {
    const footer = document.querySelector(".footer-main-container")
    if (!footer) return

    const observerOptions = {
      threshold: 0.1,
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.style.opacity = "1"
          entry.target.style.transform = "translateY(0)"
        }
      })
    }, observerOptions)

    footer.style.opacity = "0"
    footer.style.transform = "translateY(20px)"
    footer.style.transition = "opacity 0.6s ease-out, transform 0.6s ease-out"

    observer.observe(footer)
  }

  footerReveal()
})()
</script>`}
          ></Script>
        </div>
      </div>
    </div>
  )
}

export default Footer
